import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { map, Observable, tap } from 'rxjs';
import { FeatureFlag, FeatureFlagsService } from './feature-flags.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagGuardService {
  constructor(
    private _featureFlagsService: FeatureFlagsService,
    private _router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const requestedFeatureFlags = (route.data.featureFlags as Array<FeatureFlag>) ?? [];
    return this._featureFlagsService.whenReleaseFlagsReady$().pipe(
      map(() => requestedFeatureFlags.every(flag => this._featureFlagsService.isFeatureFlagEnabled(flag))),
      tap(isAllowed => {
        if (!isAllowed) {
          void this._router.navigate(['/404']);
        }
      })
    );
  }
}
